<script lang="ts" setup>
import { computed } from 'vue';
import AfterMarketTable from '../AfterMarketTable.vue';
import AfterMarketTableSkeleton from '../AfterMarketTableSkeleton.vue';
import type { AfterMarketRow, AfterMarketSaveCallbacks } from '../types';
import { useAfterMarketTableMutation } from './useAfterMarketTableMutation';
import { useAfterMarketTableQuery } from './useAfterMarketTableQuery';

const props = defineProps<{
  projectId: string;
  mode?: 'read-only' | 'edit';
}>();

const query = useAfterMarketTableQuery(() => props.projectId);
const mutation = useAfterMarketTableMutation(() => props.projectId);

const afterMarketTableProps = computed(() => ({
  initialRows:
    query.data.value?.map((v) => ({
      id: v.id,
      text: v.text,
      date: v.date ?? '',
    })) ?? [],
  mode: props.mode,
}));

const isFirstLoad = computed(() => query.isLoading.value);

const onSave = (
  rows: AfterMarketRow[],
  callbacks: AfterMarketSaveCallbacks,
) => {
  mutation.mutate(rows, {
    onSuccess: callbacks.onSuccess,
    onError: callbacks.onError,
  });
};
</script>

<template>
  <AfterMarketTableSkeleton v-if="isFirstLoad" />
  <AfterMarketTable v-else v-bind="afterMarketTableProps" @save="onSave" />
</template>

<style scoped></style>
